import React from "react";

const NotificationCard = () => {
  return (
    <div className="flex w-full items-start justify-between py-3">
      <div className="flex gap-3">
        <div className="relative flex-shrink-0">
          <div className="w-[60px] h-[60px] rounded-full border-2 border-[#E6439A] p-1">
            <div className="w-full h-full rounded-full flex items-center justify-center bg-[#B07793]">
              <span className="dcalligraphy text-[15px] text-white h-full w-full flex items-center justify-center">
                W
              </span>
            </div>
          </div>
        </div>

        {/* Content */}
        <div className="flex-1 flex flex-col w-[160px]">
          <p className="text-[16px] text-black font-normal leading-relaxed glacial">
            Hello Samantha, thank you for the suggestion.
          </p>
        </div>
      </div>

      {/* Timestamp */}
      <div className="">
        <span className="text-[14px] text-gray-400">5 mins ago</span>
      </div>
    </div>
  );
};

export default NotificationCard;
